export const RENT_MONTHLY_TITLE = `גובה שכר הדירה בשלושה חודשים אחרונים`
export const RENT_YEARLY_TITLE = `גובה שכר הדירה בהשוואה לשנה שעברה`
export const NOT_ENOUGH_DATA = `אין לנו מספיק נתונים`